import {
    CcRequirementVersion,
    CcRequirementVersionCreate,
} from "server/models"
import { GET, POST, DELETE } from "client/store/utils"
import { RequirementVersionList } from "client/store"

export const LoadCcRequirementVersions = (requirementId: number) => (
    GET(`/ccRequirementVersion/requirementId/${requirementId}`)
    .then((versions: CcRequirementVersion[]) => {
        const versionList: RequirementVersionList = {}
        const versionIds: number[] = []
        versions.forEach((version) => {
            versionList[version.id] = {
                ...version,
                typeParsed: JSON.parse(version.type),
                priorityParsed: JSON.parse(version.priority),
                statusParsed: JSON.parse(version.status),
                reviewMethodsParsed: JSON.parse(version.reviewMethods),
                smartComplianceParsed: JSON.parse(version.smartCompliance),
            }
            versionIds.push(version.id)
        })
        return {
            versionIds,
            versionList,
        }
    })
)

export const CreateCcRequirementVersion = (version: CcRequirementVersionCreate) => (
    POST(
        "/ccRequirementVersion/create",
        JSON.stringify(version),
    )
)

export const DeleteCcRequirementVersion = (versionId: number, requirementId: number) => (
    DELETE(`/ccRequirementVersion/delete/${versionId}/${requirementId}`)
    .then((removedRows: number) => removedRows)
)
